import { useEventStore } from "../store/useEventStore";
import { AlarmItem } from "../types";

let wsInstance: WebSocket | null = null;
export const startWS = (taskId: string): void => {
  if (wsInstance && wsInstance.readyState === WebSocket.OPEN) {
    console.log("[WS] Already connected, skipping");
    return;
  }

  stopWS();
  const baseUrl = import.meta.env.VITE_API_DOMAIN;

  const ws = new WebSocket(`wss://${baseUrl}/ws`);
  wsInstance = ws;

  ws.onopen = () => {
    console.log("[WS] Connected, taskId:", taskId);
  };

  ws.onmessage = (event) => {
    try {
      const newItem: AlarmItem = JSON.parse(event.data as string);
      const { items, setItems, pageCount, total } = useEventStore.getState();
      setItems([newItem, ...items], pageCount, total + 1);
    } catch (err) {
      console.error("[WS] Failed to parse message:", err);
    }
  };

  ws.onerror = (err) => {
    console.error("[WS] Error:", err);
  };

  ws.onclose = () => {
    console.warn("[WS] Closed");
    wsInstance = null;
  };
};

export const stopWS = (): void => {
  if (wsInstance) {
    wsInstance.close();
    wsInstance = null;
  }
};
